import React, { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { remark } from "remark"
import remarkHtml from "remark-html"

import Layout from "../../components/Layout"
import TitleBlock from "../../components/TitleBlock"
import HorLine from "../../components/HorLine"

import ApplicationList from "../../components/ApplicationList"

import TitleImg from "../../assets/images/pages/joinUs/titleImg.svg"
import InfoBlock from "../../components/InfoBlock"
import PowerImg from "../../assets/images/pages/joinUs/flip_bjorn.png"
import styles from "./JoinUsPage.module.scss"
import createHtml from "../../helpers/createHtml"
import findLangIndex from "../../helpers/findLangIndex";
import useGetBrowserLanguage from "../../hooks/useGetBrowserLanguage"

const JoinUsPage = ({currVacancy}) => {
    const language = useGetBrowserLanguage()

    const { vacanciesData, allMarkdownRemark } = useStaticQuery(graphql`
        query JoinUsPageQuery {
          vacanciesData: allMarkdownRemark(
            filter: {fileAbsolutePath: {regex: "/(vacancies\\/)/"}}
          ) {
            edges {
              node {
                fileAbsolutePath
                frontmatter {
                  title
                  tags
                  description
                }
                fields {
                  slug
                }
                html
              }
            }
          }
          allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/(join-us)/" } }
          ) {
            edges {
              node {
                fileAbsolutePath
                frontmatter {
                  mini_title
                  title
                  title_description
                  balance_section_title
                  balance_section_text
                }
              }
            }
          }
        }
  `)

    const remarkObj = useMemo(() => remark().use(remarkHtml), [])

    const pageData = useMemo(() => {
        const langIdxEn = findLangIndex(allMarkdownRemark?.edges, "join-us/join-us.md", "en");

        return {
          en: {
            miniTitle: allMarkdownRemark?.edges?.[langIdxEn]?.node?.frontmatter?.mini_title,
            title: allMarkdownRemark?.edges?.[langIdxEn]?.node?.frontmatter?.title,
            titleDescription: remarkObj
              .processSync(
                  allMarkdownRemark?.edges?.[langIdxEn]?.node?.frontmatter?.title_description
              )
              .toString(),
            balanceTitle: allMarkdownRemark?.edges?.[langIdxEn]?.node?.frontmatter?.balance_section_title,
            balanceText: remarkObj
              .processSync(
                  allMarkdownRemark?.edges?.[langIdxEn]?.node?.frontmatter?.balance_section_text
              )
              .toString()
          }
        }
    }, [remarkObj, allMarkdownRemark])

    const vacanciesList = useMemo(() => {
        return vacanciesData.edges.map(item => {
            const slugFields = item.node.fields.slug.match(/\/(?<lang>.*)\/vacancies\/(?<fileName>.*)\//).groups;

            return {
                slug: slugFields.fileName,
                language: slugFields.lang,
                title: item.node.frontmatter.title,
                tags: item.node.frontmatter.tags,
                description: item.node.frontmatter.description,
                text: item.node.html
            }
        });
    }, [vacanciesData]);

    return (
        <Layout>
          <TitleBlock
            className={styles.titleBox}
            miniTitle={pageData?.en?.miniTitle}
            title={pageData?.en?.title}
            image={<TitleImg className={styles.titleBox__image} />}
          >
            <div dangerouslySetInnerHTML={createHtml(pageData?.en?.titleDescription)}/>
          </TitleBlock>

          <InfoBlock
            className={styles.Block}
            title={pageData?.en?.balanceTitle}
            text={<div dangerouslySetInnerHTML={createHtml(pageData?.en?.balanceText)} />}
            link="/dynamist-experience"
            image={<img src={PowerImg} className={styles.emoji_image} alt="Title" />}
          />

          <div className={styles.grayBlock}>
            <div className={styles.grayBlock__content}>
              <ApplicationList language={language} appList={vacanciesList} selected={currVacancy}/>
            </div>
          </div>
        </Layout>
    )
}

export default JoinUsPage